import { css } from 'lit';
import { color, rem } from '@thiememeulenhoff/lit-sdk';

export const styles = css`
  /* stylelint-disable value-no-vendor-prefix */

  content {
    -webkit-box-orient: vertical;
    display: -webkit-box;
    inline-size: 100%;
    -webkit-line-clamp: var(--lines, 3);
    overflow: hidden;
  }

  footer {
    font-size: ${rem(14)};
    text-align: start;
    &.disabled {
      display: none;
    }
  }

  a {
    align-items: center;
    color: ${color('grey', 600)};
    cursor: pointer;
    display: inline-flex;
    gap: ${rem(4)};
  }

  a:hover {
    color: ${color('grey', 800)};
  }

  a:focus-visible {
    outline-color: var(--tm-focus-ring-color);
    outline-offset: var(--tm-focus-ring-offset);
    outline-style: var(--tm-focus-ring-style);
    outline-width: var(--tm-focus-ring-width);
  }
`;
